import { PropsWithChildren } from 'react';
import { Box, Container } from '@mui/material';
import { AssessmentHeader } from '../shared';
import { useProgress } from '../../providers/progress';
import Link from '../../app/link';
import { AppHeader } from '../../reusable/app-header';

type PropTypes = PropsWithChildren<{
  onBack?: () => void;
  title?: string;
  showPrivacyPolicy?: boolean;
  showProgressBar?: boolean;
  showMenu?: boolean;
}>;

export const FlowContainer = ({
  onBack,
  title,
  children,
  showPrivacyPolicy,
  showProgressBar = false,
  showMenu = false,
}: PropTypes) => {
  const { progress } = useProgress();

  /* All the flow containers have the same header variant */
  const headerVariant = 'saffron';
  const showHeaderBgImage = true;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppHeader
        variant={headerVariant}
        onBack={onBack}
        showProgressBar={showProgressBar}
        stepProgress={progress}
        showBgImage={showHeaderBgImage}
        showMenu={showMenu}
      />

      <Container
        maxWidth="sm"
        sx={{
          position: 'relative',
          flex: 1,
          mb: 3,
        }}
      >
        {title && <AssessmentHeader title={title} />}
        {children}
      </Container>
      {showPrivacyPolicy && (
        <Box sx={{ textAlign: 'center', my: 2 }}>
          <Link
            href="https://talkiatry.com/privacy-policy"
            target="_blank"
            rel="noreferrer"
            color="inherit"
            variant="caption"
          >
            Privacy Policy
          </Link>
        </Box>
      )}
    </Box>
  );
};
